module.exports = __webpack_public_path__ + "img/Marine-Reg-2.46028456.png";